/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobV2ListResponse {
    getFixupPrototypeFunction() { return TemplateJobV2ListResponse.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobV2ListResponse>): TemplateJobV2ListResponse {
        let obj = Object.assign(new TemplateJobV2ListResponse(), model);
        TemplateJobV2ListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobV2ListResponse>): TemplateJobV2ListResponse {
        if (!model) return null;
        return TemplateJobV2ListResponse.newInstance(<TemplateJobV2ListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobV2ListResponse) {
        if (!obj) return;

        models.TemplateJobV2ListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobV2ListResponse): boolean {
        Object.setPrototypeOf(obj, TemplateJobV2ListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
    }

    /**
     * List of result identifiers
     */
    results: Array<string>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

}
